import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
  startAfter,
  DocumentData,
  QueryDocumentSnapshot,
  QueryConstraint
} from '@firebase/firestore';
import { firestoreDb } from 'src/constants';
import { UserList } from '../data/interfaces/users-list';

export async function getUsersList(params: {
  provider?: string;
  value?: string;
  filteredField?: string;
  order?: boolean;
  rowsPerPage?: number;
  doc?: QueryDocumentSnapshot<DocumentData>;
}): Promise<UserList[]> {
  const { provider, value, filteredField, order, rowsPerPage, doc } = params;
  let constraints: QueryConstraint[] = [limit(rowsPerPage)];

  if (provider && value) {
    constraints.push(where(provider, '==', value));
  }

  if (filteredField) {
    constraints.push(orderBy(filteredField, order ? 'asc' : 'desc'));
  }

  if (doc) {
    constraints.push(startAfter(doc));
  }

  const q = query(
    collection(firestoreDb, 'users'),
    ...constraints,
    limit(rowsPerPage)
  );
  const snapshot = await getDocs(q);

  const res = await Promise.all(
    snapshot.docs.map(async (doc) => {
      const user = doc.data() as UserList;
      let referralCode = '';

      if (user.uid) {
        const codeQuery = query(
          collection(firestoreDb, `users/${user.uid}/referrals`)
        );
        const referralDoc = (await getDocs(codeQuery)).docs[0];
        referralCode = referralDoc?.data()?.referralCode || '';
      }

      return {
        ...user,
        referralCode,
        doc
      };
    })
  );

  return res;
}
